import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import useForm from 'react-hook-form';
import PropTypes from 'prop-types';
import Select from 'react-select';
/* actions */
import {
  getAllDepartments,
  addDepartments
} from '../../redux/actions/departments';
import { getAllCompanies } from '../../redux/actions/companies';
/* components */
import ErrorMsgField from '../../components/ErrorMsgField';
import AlertMsg from '../../components/AlertMsg';
import FormFooter from '../../components/FormFooter';
import FormHeader from '../../components/FormHeader';
/* form-validation */
import schema from '../../form-validation/department';
/* utils */
import handleChangeDefault from '../../utils/handleChangeDefault';
import { idCompany4Case } from '../../utils/defaultPermissions';
import {
  customStyle,
  customThemes,
  customFilter,
  firstOption,
  handleChangeSelect
} from '../../utils/select';
import sortable from '../../utils/sortable';

function Add (props) {
  const { handleModalClose } = props;
  const INITIAL_VALUES = {
    name: '',
    macroDepartment: '',
    description: '',
    company: ''
  };
  const dispatch = useDispatch();
  const submitButton = useRef();
  const { register, handleSubmit, errors, reset, setError, setValue } = useForm(
    {
      validationSchema: schema,
      reValidateMode: 'onSubmit'
    }
  );
  const sessionUser = useSelector(state => state.authentications.user);
  const company = sessionUser.company._id;
  const departments = useSelector(state => state.departments);
  const [data, setData] = useState(INITIAL_VALUES);
  const companies = useSelector(state => state.companies.data);
  const [companyOptions, setCompanyOptions] = useState([firstOption]);

  useEffect(() => {
    dispatch(getAllDepartments());
    dispatch(
      getAllCompanies(idCompany4Case === company ? {} : { _id: company })
    );
  }, [dispatch]);

  useEffect(() => {
    if (companies.length) {
      const options = companies
        .map(company => ({
          value: company._id,
          label: `${company.name}`,
          sortValue: `${company.name}`
        }))
        .sort(sortable);

      options.unshift(firstOption);
      setCompanyOptions([...options]);
    }
  }, [companies, setCompanyOptions]);

  const submit = () => {
    const resetForm = () => {
      reset();
      setData({ ...INITIAL_VALUES });
    };
    dispatch(addDepartments(data, resetForm, submitButton.current));
  };

  return (
    <div className="container-fluid">
      {departments.addSuccess && (
        <AlertMsg type="success" msg="Departamento cadastrado com sucesso" />
      )}
      {departments.errorContent &&
        !departments.errorContent.message.includes('400') &&
        departments.addError && (
        <AlertMsg
          type="danger"
          msg="Falha durante cadastro do departamento"
        />
      )}
      {departments.errorContent &&
        departments.errorContent.message.includes('400') &&
        departments.addError && (
        <AlertMsg
          type="danger"
          msg="Um departamento com o nome informado já está cadastrado"
        />
      )}
      {!departments.addSuccess && !departments.addError && (
        <AlertMsg type="info" msg="Área cadastro de departamentos" />
      )}
      <FormHeader title="Cadastrar Departamento" />
      <form onSubmit={handleSubmit(submit)}>
        <div className="form-group">
          <label htmlFor="name">
            Nome<span className="field-required">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            id="name"
            name="name"
            autoComplete="off"
            value={data.name}
            onChange={evt => handleChangeDefault(evt, data, setData)}
            ref={register}
          />
          {errors.name && errors.name.type === 'required' && (
            <ErrorMsgField type="required" />
          )}
        </div>
        <div className="form-group">
          <label htmlFor="macroDepartment">
            Macro Departamento<span className="field-required">*</span>
          </label>
          <select
            className="form-control"
            id="macroDepartment"
            name="macroDepartment"
            value={data.macroDepartment}
            onChange={evt => handleChangeDefault(evt, data, setData)}
            ref={register}
          >
            <option value="">-- Selecione --</option>
            {departments.data.map((dpt, i) => {
              const _id = dpt._id || Date.now() + '' + i;
              return (
                <option key={_id} value={_id}>
                  Dpto: {dpt.name} - Empresa: {dpt.company.name}
                </option>
              );
            })}
          </select>
          {errors.macroDepartment &&
            errors.macroDepartment.type === 'required' && (
            <ErrorMsgField type="required" />
          )}
        </div>
        <div className="form-group">
          <div className="form-group form-inline mb-0">
            <label className="col-sm-12 d-inline p-0 mb-2" htmlFor="company">
              Empresa
              <span className="field-required">*</span>
            </label>
            <Select
              className="col p-0"
              name="company"
              ref={register}
              onChange={evt =>
                handleChangeSelect(
                  { ...evt, name: 'company' },
                  data,
                  setData,
                  setError,
                  setValue
                )
              }
              value={companyOptions.find(
                company => company.value === data.company
              )}
              options={companyOptions}
              isSearchable={true}
              theme={customThemes}
              styles={customStyle}
              filterOption={customFilter}
              noOptionsMessage={() => 'Nenhum registro encontrado'}
            />
          </div>
          {errors.company && errors.company.type === 'required' && (
            <ErrorMsgField type="required" />
          )}
        </div>
        <div className="form-group">
          <label htmlFor="description">
            Descrição<span className="field-required">*</span>
          </label>
          <textarea
            className="form-control"
            id="description"
            name="description"
            rows="3"
            value={data.description}
            onChange={evt => handleChangeDefault(evt, data, setData)}
            ref={register}
          ></textarea>
          {errors.description && errors.description.type === 'required' && (
            <ErrorMsgField type="required" />
          )}
        </div>
        {handleModalClose ? (
          <div className="container-fluid p-0">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleModalClose}
            >
              <i className="fa fa-times"></i>
              &nbsp;Fechar
            </button>
            <button
              type="submit"
              ref={submitButton}
              className="btn btn-primary float-right"
            >
              <i className="fa fa-save"></i>
              &nbsp;Salvar
            </button>
          </div>
        ) : (
          <FormFooter url="/departments" reference={submitButton} />
        )}
      </form>
    </div>
  );
}

Add.propTypes = {
  handleModalClose: PropTypes.func
};

export default Add;
